const home = {
      namespaced:true,
      state:{
        token:'',
        acount:'',
      },
      getters:{},
      mutations:{
        setToken(state,token){
            sessionStorage.setItem(`token`,token)
            state.token=token;
        },
        setAcount(state,n){
            state.acount = n
        }
      },
      actions:{
        updateToken(context,value){
            context.commit('setToken',value)
        },
        setAcount({commit,state},n){
           commit('setAcount',n)
        }
      }
}

export default home